import { userInfoSync } from 'hub-http/userInfo';
import { useMemo, memo, useEffect } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import { createDefaultCrmCommandHandlers } from './createDefaultCrmCommandHandlers';
import CallbackRegistration from './registers/CallbackRegistration';
import ModalRegistration from './registers/ModalRegistration';
import { createTracker } from 'usage-tracker';
import events from '../events.yaml';
import { useGeneralStoreRelays } from './useGeneralStoreRelays';
import Raven from 'raven-js';
import { logIfIframe } from './utils/logIfIframe';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultUsageTracker = createTracker({
  events
});
function CrmCommandHandler({
  disableDefaultHandlers = [],
  customTopicHandlers = {},
  features = [],
  floatingAlertStoreInstance: floatingAlertStoreInstanceProp,
  i18nLoader,
  onCommunicatorClick,
  usageTracker = DefaultUsageTracker
}) {
  useGeneralStoreRelays();

  // If there is a problem getting gates from UserInfoSync, we should not block the rendering of the component
  const gates = useMemo(() => {
    try {
      return userInfoSync().gates;
    } catch (e) {
      Raven.captureException(e);
    }
    return [];
  }, []);
  const floatingAlertStoreInstance = useMemo(() => {
    if (floatingAlertStoreInstanceProp) {
      return floatingAlertStoreInstanceProp;
    }
    return FloatingAlertStore.newFloatingAlertStore();
  }, [floatingAlertStoreInstanceProp]);
  const handlerMap = useMemo(() => Object.assign({}, createDefaultCrmCommandHandlers({
    floatingAlertStoreInstance,
    disableDefaultHandlers,
    gates
  }), customTopicHandlers), [gates, disableDefaultHandlers, customTopicHandlers, floatingAlertStoreInstance]);
  const topicNames = useMemo(() => {
    return Object.keys(handlerMap).sort();
  }, [handlerMap]);
  useEffect(() => {
    logIfIframe('CrmCommandHandler was loaded in an iframe');
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!floatingAlertStoreInstanceProp && /*#__PURE__*/_jsx(UIFloatingAlertList, {
      alertStore: floatingAlertStoreInstance
    }), topicNames.map(topic => {
      const handler = handlerMap[topic];
      if (!handler) {
        return null;
      }
      if (handler.type === 'CALLBACK') {
        return /*#__PURE__*/_jsx(CallbackRegistration, {
          handler: handler
        }, `${topic}-HANDLER`);
      } else if (handler.type === 'MODAL') {
        return /*#__PURE__*/_jsx(ModalRegistration, {
          features: features,
          handler: handler,
          i18nLoader: i18nLoader,
          onCommunicatorClick: onCommunicatorClick,
          usageTracker: usageTracker
        }, `${topic}-HANDLER`);
      }
      return null;
    })]
  });
}
export default /*#__PURE__*/memo(CrmCommandHandler);